import { render, staticRenderFns } from "./UseWeeksContent.vue?vue&type=template&id=2c0db02b"
import script from "./UseWeeksContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./UseWeeksContent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports